import { useRef, useState, useEffect, useCallback } from 'react';
const useEllipsis = (maxLines) => {
    const ref = useRef(null);
    const [isTruncated, setTruncated] = useState(false);
    function getHtmlElement(currentRef) {
        const classNames = currentRef.classList;
        const selector = Array.from(classNames);
        return document.querySelector(`.${selector}`);
    }
    const getLineHeight = useCallback((element) => {
        const { lineHeight } = window.getComputedStyle(element);
        if (lineHeight === 'normal') {
            const { fontSize } = window.getComputedStyle(element);
            return parseFloat(fontSize) * 1.25;
        }
        return parseFloat(lineHeight);
    }, []);
    useEffect(() => {
        if (maxLines && ref.current) {
            const { current } = ref;
            const element = getHtmlElement(current);
            const elementStyles = window.getComputedStyle(current);
            if (element && maxLines) {
                const lineHeight = getLineHeight(element);
                const maxHeight = Math.ceil(Number(lineHeight) * maxLines);
                const scrollHeight = current.clientHeight -
                    parseFloat(elementStyles.paddingTop) -
                    parseFloat(elementStyles.paddingBottom);
                setTruncated(scrollHeight > maxHeight);
            }
        }
    }, [ref, maxLines, getLineHeight, setTruncated]);
    return {
        ref,
        isTruncated
    };
};
export default useEllipsis;
//# sourceMappingURL=index.js.map